export type WizardMode = "create" | "edit";

export interface WizardStep {
  key: string;
  title: string;
}

export const PARTNER_WIZARD_STEPS: WizardStep[] = [
  { key: "details", title: "Partner details" },
  { key: "type", title: "Partner type" },
  { key: "inPersonPricing", title: "In-person pricing" },
  { key: "onlinePricing", title: "Online pricing" },
  { key: "coupling", title: "Terminal coupling platform" },
];
